import axios from "axios";
import React, {Component} from "react";
import { Link } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';

const sectionLinks = [
  { id: "top", label: "Accueil", icon: "home" },
  { id: "support", label: "Services", icon: "grid" },
  { id: "ecoles", label: "Ecoles", icon: "map" },
];

class Navbar extends Component{

  state = {
    count : "3",
    chats : [],
    activeSection: "top",
    menuOpen: false,
    scrolled: false,
  }

  componentDidMount(){
    this.getNotifications()
    this.updatePageState();
    window.addEventListener("scroll", this.updatePageState, { passive: true });
    window.addEventListener("hashchange", this.updateActiveSection);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updatePageState);
    window.removeEventListener("hashchange", this.updateActiveSection);
  }

  async getNotifications()
  {
    var user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : false;
    if(!user) {
      return;
    }

      var chats = await axios.get('notifications');
      if(chats.status == 200)
      {
          this.setState({
              chats : chats.data,
              loading : true
          })
      }
  } 

 
  logout = (e) => {
    axios.post('logout').catch(() => {});
    window.localStorage.clear();
    window.location.replace(process.env.REACT_APP_EVIVESOMA)
}

  updateActiveSection = () => {
    const current = sectionLinks.reduce((active, item) => {
      const section = document.getElementById(item.id);
      if (!section) {
        return active;
      }

      const top = section.getBoundingClientRect().top;
      return top <= 118 ? item.id : active;
    }, "top");

    if (current !== this.state.activeSection) {
      this.setState({ activeSection: current });
    }
  };

  updatePageState = () => {
    this.updateActiveSection();
    const scrolled = window.scrollY > 16;
    if (scrolled !== this.state.scrolled) {
      this.setState({ scrolled });
    }
  };

  toggleMenu = () => {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  };

  closeMenu = () => {
    this.setState({ menuOpen: false });
  };

  getHomeHref = (id) => `${process.env.REACT_APP_EVIVESOMA || ""}/#${id}`;

    render(){
      var user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : false;
      
      var exist = [], count = 0;
        this.state.chats.forEach((box) => {
            if(exist.filter(dat => dat == box.id).length == 0)
            {
              exist.push(box.id)
                if(box.userchats?.readAt){
                    count = count;
                }
                else{
                    count = count + 1;
                }
            }
        })

      
      return(
        <nav
          className={`navbar evive-navbar${this.state.scrolled ? " is-scrolled" : ""}${this.state.menuOpen ? " menu-open" : ""}`}
          aria-label="Navigation principale"
        >
            <div className="container evive-nav-container">
              <Link className="navbar-brand evive-brand" to="/">
                <span className="evive-brand-mark"><img src="/logo192.png" alt="logo evivesoma" /></span>
                <span className="evive-brand-text">
                  <strong>{ process.env.REACT_APP_NAME || "EviveSoma" }</strong>
                  <small>Gestion scolaire</small>
                </span>
              </Link>
              <button
                className="evive-menu-toggle"
                type="button"
                aria-label={this.state.menuOpen ? "Fermer le menu" : "Ouvrir le menu"}
                aria-expanded={this.state.menuOpen}
                aria-controls="eviveNavigation"
                onClick={this.toggleMenu}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              <div className={`evive-nav-actions${this.state.menuOpen ? " is-open" : ""}`} id="eviveNavigation">
                <ul className="navbar-nav ms-auto align-items-center">
                  {sectionLinks.map((item) => (
                    <li className="nav-item" key={item.id}>
                      <a
                        className={`nav-link evive-nav-link ${this.state.activeSection === item.id ? "active" : ""}`}
                        aria-current={this.state.activeSection === item.id ? "page" : undefined}
                        href={this.getHomeHref(item.id)}
                        onClick={() => this.setState({ activeSection: item.id, menuOpen: false })}
                      >
                        <FeatherIcon icon={item.icon} size={15}></FeatherIcon>
                        <span>{item.label}</span>
                      </a>
                    </li>
                  ))}
                  { 
                    user != false && (<>
                      <li className="nav-item">
                        <a className="nav-link evive-nav-link evive-notification-link" aria-current="page" href={ process.env.REACT_APP_EVIVESOMA + "/notifications" }>
                          <FeatherIcon icon={"bell"} size={15}></FeatherIcon>
                          <span>Alertes</span>
                          {count > 0 ? <span className="evive-nav-badge">{count > 9 ? "+9" : count}</span> : null}
                        </a>
                      </li>
                      <li className="nav-item"><a className="nav-link evive-nav-link evive-nav-cta" href={ this.getHomeHref("profile") } onClick={this.closeMenu}><FeatherIcon icon={"activity"} size={15}></FeatherIcon> Suivi parent</a></li>
                     </>)
                  }
                  </ul>
              </div>
            </div>
            {this.state.menuOpen && <button className="evive-nav-backdrop" type="button" aria-label="Fermer le menu" onClick={this.closeMenu}></button>}
          </nav>
        )
    }
}
export default Navbar;
